/**
 * menuRelevantVersionsChanged — 判断服务端版本号变化是否影响用户菜单树。
 *
 * 背景(menu session E#5 / 2026-06-12 接线):前端菜单存 localStorage
 * `menu_permissions`,checkAuthStatus 1 小时内不重拉 —— 后端改了菜单/角色,
 * 前端最长 1 小时才能看到。后端的版本信号链路现在是全的(MENU/ROLES/USERS
 * 由 listener 可靠 bump,含 M2M 链接表与裸 SQL 删除路径),这里把菜单接上
 * 既有的 versions 轮询(bootstrap + 路由级 5min 节流):相关版本一变 →
 * dispatch(loadUserMenus()) 绕过 1h 闸立即重拉。1h localStorage 闸保留,
 * 作为"无版本信号可用"时的兜底。
 *
 * 菜单树的派生输入:menu 实体(MENU)、role_menu/角色(ROLES)、user_role
 * 归属(USERS)。版本 key 形如 "menu:tenant:7" / "roles:tenant:7"。
 */
const MENU_VERSION_PREFIXES = ['menu:', 'roles:', 'users:'] as const

export function menuRelevantVersionsChanged(
  prev: Record<string, string> | null | undefined,
  next: Record<string, string> | null | undefined,
): boolean {
  // 首次(本地无快照)不触发:此时菜单刚由登录流程加载,无需追加一次重拉
  if (!prev || Object.keys(prev).length === 0) return false
  if (!next) return false
  for (const key of Object.keys(next)) {
    if (
      MENU_VERSION_PREFIXES.some((p) => key.startsWith(p)) &&
      prev[key] !== next[key]
    ) {
      return true
    }
  }
  return false
}
